export default "__VITE_ASSET__CKVGIozX__"